import { render, staticRenderFns } from "./manualsvs.vue?vue&type=template&id=82f4ae3c&scoped=true&"
import script from "./manualsvs.vue?vue&type=script&lang=js&"
export * from "./manualsvs.vue?vue&type=script&lang=js&"
import style0 from "./manualsvs.vue?vue&type=style&index=0&id=82f4ae3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f4ae3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82f4ae3c')) {
      api.createRecord('82f4ae3c', component.options)
    } else {
      api.reload('82f4ae3c', component.options)
    }
    module.hot.accept("./manualsvs.vue?vue&type=template&id=82f4ae3c&scoped=true&", function () {
      api.rerender('82f4ae3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/manualsvs.vue"
export default component.exports